import './App.css';

import { CacheBuster } from './components/react/CacheBuster';
import { SceneViewer } from './components/react/SceneViewer';

function App() {
  return (
    <CacheBuster>
      <SceneViewer sceneID="project" />
    </CacheBuster>
  );
}

export default App;
